import React from 'react'
import { ButtonProps, Button, ThemeProvider  } from '@material-ui/core'
import { warnTheme } from '../../../themes/mui'

export function WarnButton(props: ButtonProps) {
    return (
        <ThemeProvider  theme={warnTheme}>
            <Button {...props} color="primary" />
        </ThemeProvider >
    )
}

